import { render, staticRenderFns } from "./feature-view.vue?vue&type=template&id=56d258ce&scoped=true"
import script from "./feature-view.vue?vue&type=script&lang=js"
export * from "./feature-view.vue?vue&type=script&lang=js"
import style0 from "./feature-view.vue?vue&type=style&index=0&id=56d258ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d258ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1671620415/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d258ce')) {
      api.createRecord('56d258ce', component.options)
    } else {
      api.reload('56d258ce', component.options)
    }
    module.hot.accept("./feature-view.vue?vue&type=template&id=56d258ce&scoped=true", function () {
      api.rerender('56d258ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/feature-view.vue"
export default component.exports